module.exports = __webpack_public_path__ + "img/43a2138.png";